
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 69 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.15 17.57v-2.375h2.265c1.593 0 3.275-.418 3.298-1.847 0-.88-.718-2.046-3.23-2.046-1.392 0-3.276.484-3.276 1.892H.247c0-3.321 3.365-4.53 6.258-4.53 2.962 0 6.147 1.406 6.17 4.684 0 1.21-.808 2.617-2.177 3.034 1.503.484 2.558 1.936 2.558 3.233 0 3.761-3.612 4.883-6.64 4.883-2.984 0-6.393-1.232-6.416-4.729h2.983c0 1.584 2.176 2.134 3.455 2.134 1.503 0 3.5-.616 3.5-2.265 0-.924-.516-2.068-3.343-2.068H4.15zM18.013 13.61v2.31c.696-1.056 2.4-1.628 3.634-1.628 3.163 0 6.483 1.297 6.483 5.124 0 3.41-3.342 5.102-6.505 5.102-3.207 0-6.55-1.693-6.55-5.146v-5.74c0-3.43 3.23-5.036 6.46-5.036 3.41 0 6.439 1.32 6.439 4.553h-2.961c0-1.364-1.75-2.046-3.432-2.046-1.773-.022-3.567.924-3.567 2.595v-.088zm7.179 5.806c0-1.693-1.57-2.594-3.545-2.594-1.973 0-3.656.88-3.634 2.594.023 1.694 1.683 2.507 3.612 2.507 1.863 0 3.567-.813 3.567-2.507zM41.793 11.63h-8.481v2.706h3.052c3.342 0 6.326 1.341 6.304 4.948 0 3.497-2.984 5.169-6.147 5.169-3.455 0-6.416-1.21-6.438-4.817h2.938c0 1.694 1.974 2.133 3.454 2.133 1.436 0 3.253-.66 3.253-2.485.022-1.737-1.75-2.243-3.365-2.243H30.42V8.904h11.374v2.727zM65.9.5a2.76 2.76 0 00-1.328 5.18l-5.6 13.722a2.76 2.76 0 00-2.322.24l-5.952-6.813a2.757 2.757 0 10-.736.643l5.952 6.813a2.75 2.75 0 00-.605 1.724c0 1.525 1.083 2.76 2.76 2.76 1.677 0 2.76-1.235 2.76-2.76a2.754 2.754 0 00-.998-2.124l5.67-13.894A2.76 2.76 0 1065.9.5z","fill":"#fff"}})])
          )
        }
      }
    